import React from "react";
import PropTypes from "prop-types";

export default function SecureSVG(props) {
  return (
    <svg
      version="1.1"
      id={props.id || ''}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 93 105"
      fill={props.styles.fill}
      height={props.styles.height}
      width={props.styles.width}
      className={props.className || ''}
    >
      <g>
        <path
          className="st0"
          d="M85.2,64.1V40.9c4.5-0.9,7.8-4.9,7.8-9.7c0-5.5-4.4-9.9-9.8-9.9c-1.1,0-2,0.9-2,2s0.9,2,2,2
		c3.2,0,5.8,2.6,5.8,5.9s-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.6-5.8-5.9c0-0.3,0-0.7,0.1-1l4.7,2.8c0.3,0.2,0.7,0.3,1,0.3
		c0.7,0,1.4-0.4,1.7-1c0.6-1,0.2-2.2-0.7-2.7l-6.8-3.9l0,0l0,0L55.8,13c0.3-1,0.5-2,0.5-3.1c0-5.5-4.4-9.9-9.8-9.9s-9.8,4.4-9.8,9.9
		c0,1.1,0.2,2.1,0.5,3.1l-20,11.6c-1.8-2-4.4-3.3-7.3-3.3c-5.4,0-9.8,4.4-9.8,9.9c0,4.8,3.4,8.7,7.8,9.7v23.3
		C3.4,65.1,0,69.1,0,73.8c0,5.4,4.4,9.9,9.8,9.9c1.1,0,2-0.9,2-2s-0.9-2-2-2c-3.2,0-5.8-2.6-5.8-5.9s2.6-5.9,5.8-5.9
		s5.8,2.6,5.8,5.9c0,0.3,0,0.7-0.1,1l-4.7-2.8c-0.9-0.6-2.2-0.2-2.7,0.7S7.9,75,8.8,75.5L37.2,92c-0.3,1-0.5,2-0.5,3.1
		c0,5.4,4.4,9.9,9.8,9.9s9.8-4.4,9.8-9.9c0-1.1-0.2-2.1-0.5-3.1l20-11.6c1.8,2,4.4,3.3,7.3,3.3c5.4,0,9.8-4.4,9.8-9.9
		C93,69.1,89.6,65.1,85.2,64.1z M83.2,79.7c-3.2,0-5.8-2.6-5.8-5.9c0-1,0.3-2.1,0.8-2.9c0.6-1,0.2-2.2-0.7-2.7s-2.2-0.2-2.7,0.7
		c-0.9,1.5-1.3,3.2-1.3,4.9c0,1.1,0.2,2.1,0.5,3.1L52.3,89.4c0,0,0,0,0,0c0,0,0,0,0,0l-6.8,3.9c-1,0.6-1.3,1.8-0.7,2.7
		c0.4,0.6,1,1,1.7,1c0.3,0,0.7-0.1,1-0.3l4.7-2.8c0.1,0.3,0.1,0.7,0.1,1c0,3.2-2.6,5.9-5.8,5.9s-5.8-2.6-5.8-5.9s2.6-5.9,5.8-5.9
		c1.1,0,2-0.9,2-2s-0.9-2-2-2c-2.9,0-5.5,1.3-7.3,3.3l-20-11.6c0.3-1,0.5-2,0.5-3.1c0-4.8-3.4-8.7-7.8-9.7V31.2c0-1.1-0.9-2-2-2
		s-2,0.9-2,2v5.5c-2.2-0.8-3.8-3-3.8-5.5c0-3.2,2.6-5.9,5.8-5.9s5.8,2.6,5.8,5.9c0,1-0.3,2.1-0.8,2.9c-0.6,1-0.2,2.2,0.7,2.7
		s2.2,0.2,2.7-0.7c0.9-1.5,1.3-3.2,1.3-4.9c0-1.1-0.2-2.1-0.5-3.1l28.4-16.5c1-0.6,1.3-1.8,0.7-2.7s-1.8-1.3-2.7-0.7l-4.7,2.8
		c-0.1-0.3-0.1-0.7-0.1-1c0-3.2,2.6-5.9,5.8-5.9s5.8,2.6,5.8,5.9s-2.6,5.9-5.8,5.9c-1.1,0-2,0.9-2,2s0.9,2,2,2
		c2.9,0,5.5-1.3,7.3-3.3l20,11.6c-0.3,1-0.5,2-0.5,3.1c0,4.8,3.4,8.7,7.8,9.7v32.9c0,1.1,0.9,2,2,2s2-0.9,2-2v-5.5
		c2.2,0.8,3.8,3,3.8,5.5C89,77.1,86.4,79.7,83.2,79.7z"
        />
        <path
          className="st0"
          d="M46.5,44.4c-3.2,0-6.2,0.9-8.7,2.5v-6.2c0-4.8,3.9-8.7,8.7-8.7s8.7,3.9,8.7,8.7c0,1.1,0.9,2,2,2s2-0.9,2-2
		c0-7-5.7-12.7-12.7-12.7s-12.7,5.7-12.7,12.7v9.7c-2.3,2.8-3.6,6.3-3.6,10.2c0,9,7.3,16.3,16.3,16.3s16.3-7.3,16.3-16.3
		S55.5,44.4,46.5,44.4z M46.5,73c-6.8,0-12.3-5.5-12.3-12.3s5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3S53.3,73,46.5,73z"
        />
        <path
          className="st0"
          d="M46.5,56.2c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2v-5C48.5,57.1,47.6,56.2,46.5,56.2z"
        />
      </g>
    </svg>
  );
}

SecureSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
